import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from '@99designs/emu';
import { DesignerAttribution, DesignerAttributionProps } from './DesignerAttribution';

type DesignerImageStyleProps = {
    borderRadius?: string;
};

type DesignerAttributionStyleProps = {
    attributionPadding?: string;
};

type DesignerImageProps = {
    image: string;
    imgAlt?: string;
} & DesignerImageStyleProps &
    DesignerAttributionProps &
    DesignerAttributionStyleProps;

const AttributionPlacement = styled.div<DesignerAttributionStyleProps>`
    text-align: end;
    ${({ attributionPadding }) =>
        attributionPadding &&
        css`
            padding-top: ${attributionPadding};
        `}
`;

const Image = styled.img<DesignerImageStyleProps>`
    ${({ borderRadius }) =>
        borderRadius &&
        css`
            border-radius: ${borderRadius};
        `}
`;

export function DesignerImage({
    image,
    imgAlt,
    borderRadius,
    attributionPadding,
    ...attributionProps
}: DesignerImageProps) {
    return (
        <Box>
            <Image src={image} alt={imgAlt} borderRadius={borderRadius} />
            <AttributionPlacement attributionPadding={attributionPadding}>
                <DesignerAttribution {...attributionProps} />
            </AttributionPlacement>
        </Box>
    );
}
